import React from 'react'
import type { UserSelectProps } from '../User/UserSelect/UserSelect'
import { UserSelect } from '../User/UserSelect/UserSelect'
import { gql } from '@apollo/client'

const collaboratorsQuery = gql`
  query getCollaboratorUsers($filter: JSON!, $options: JSON) {
    getCollaboratorUsers(filter: $filter, options: $options) {
      _id
      profile {
        _id
        name
        email
        picture
      }
      status
      company {
        _id
        name
        domain
      }
    }
  }
`

const defaultDataLoadOptions = (filter = {}) => ({
  query: collaboratorsQuery,
  filter: ({ input }) => {
    return {
      $or: [
        { 'profile.name': { $regex: input, $options: 'i' } },
        {
          'profile.email': {
            $regex: input,
            $options: 'i',
          },
        },
      ],
      ...filter,
    }
  },
  resultFieldName: 'getCollaboratorUsers',
})

export const MembersSelect = ({ filter, dataLoadOptions: _dataLoadOptions, ...props }: UserSelectProps) => {
  return (
    <UserSelect
      filter={filter}
      dataLoadOptions={defaultDataLoadOptions(filter)}
      {...{
        ...props,
        isMulti: true,
        cacheOptions: false,
        placeholder: 'Search user',
      }}
    />
  )
}
